import React from 'react';
import { useAuth } from './AuthProvider';
import { useTwoFactorAuth } from './TwoFactorAuthProvider';
import { TwoFactorVerification } from './TwoFactorVerification';

interface AuthenticationFlowProps {
  children: React.ReactNode;
}

export const AuthenticationFlow: React.FC<AuthenticationFlowProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const { requires2FA, is2FAVerified, loading: twoFactorLoading } = useTwoFactorAuth();

  // Show loading state only for initial auth or when 2FA verification is actually needed
  if (loading || (user && twoFactorLoading && requires2FA && !is2FAVerified)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verifying security...</p>
        </div>
      </div>
    );
  }

  // If no user, show children (this will be handled by ProtectedRoute)
  if (!user) {
    return <>{children}</>;
  }

  // If user is logged in but 2FA is required and not verified, show 2FA verification
  // This prevents any protected content from being displayed before 2FA verification
  if (requires2FA && !is2FAVerified) {
    return <TwoFactorVerification />;
  }

  // If user is logged in and 2FA is verified (or not required), show the main app
  return <>{children}</>;
}; 